<div class="p-2">

  <!-- Title -->
  <div class="row">
    <div class="col-12 h5 text-muted p-0">Payments</div>
  </div>

  <div class="row bg-light p-2">
    <div class="col-12">

      <!-- Filters -->
      <div class="row bg-white pt-2 pb-2">
        <div class="col-12">
          <app-report-filters page="regional-coupon-payments" [showCalendar]="true" [showCouponSourceRetailer]="false" (filterChange)="onfilterChange($event)"></app-report-filters>
        </div>
      </div>

      <!-- Payment Info -->
      <div class="row bg-light mt-2">
        <div class="col-6 p-0">
          <div class="card payment-info-box bg-info text-white">
            <div class="card-body">
              <div class="title text-uppercase">Coupon Payments ({{ reportFilter?.date_range[0] | date: 'MMM d, y' }} - {{ reportFilter?.date_range[1] | date: 'MMM d, y' }})</div>

              <div class="row">
                <div class="col-6">
                  <div class="spinner-grow spinner-grow-sm text-white mt-2" role="status" *ngIf="paymentsFilterLoading === true"></div>
                  <h2 class="card-title" *ngIf="paymentsFilterLoading === false">{{ paymentsFilter?.total_amount | currency }}</h2>
                </div>
                <div class="col-6 text-light text-end">
                  <div class="details">{{ paymentsFilterNoOfDays }} Days</div>
                  <div class="details">Avg: {{ paymentsFilter?.avg_amount | currency }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-6 p-0">
          <div class="card payment-info-box bg-info text-white float-end">
            <div class="card-body">
              <div class="title text-uppercase">Coupon Payments (Year to date)</div>

              <div class="row">
                <div class="col-6">
                  <div class="spinner-grow spinner-grow-sm text-white mt-2" role="status" *ngIf="paymentsYearLoading === true"></div>
                  <h2 class="card-title" *ngIf="paymentsYearLoading === false">{{ paymentsYear?.total_amount | currency }}</h2>
                </div>
                <div class="col-6 text-light text-end">
                  <div class="details">{{ paymentsYearNoOfDays }} Days</div>
                  <div class="details">Avg: {{ paymentsYear?.avg_amount | currency }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row mt-2 pb-2">
        <!-- Payment details by coupon -->
        <div class="col-9 bg-white border-end border-3 border-light">

          <!-- Title -->
          <span class="text-muted fw-bold mt-2">Payments by Coupon</span>

          <!-- Header -->
          <div class="row coupons-header-row border-bottom m-1">
            <div class="col-3 title text-muted cursor-pointer" (click)="changeCouponsSorting('coupon_title')">
              Coupons
              <i-bs class="text-secondary" name="sortUpAlt" *ngIf="coupons.length != 0 && couponsSortType == 'asc' && couponsSortField == 'coupon_title'"></i-bs>
              <i-bs class="text-secondary" name="sortDown" *ngIf="coupons.length != 0 && couponsSortType == 'desc' && couponsSortField == 'coupon_title'"></i-bs>
            </div>
            <div class="col-3 title text-muted cursor-pointer" (click)="changeCouponsSorting('mfg_name')">
              Manufacturer
              <i-bs class="text-secondary" name="sortUpAlt" *ngIf="coupons.length != 0 && couponsSortType == 'asc' && couponsSortField == 'mfg_name'"></i-bs>
              <i-bs class="text-secondary" name="sortDown" *ngIf="coupons.length != 0 && couponsSortType == 'desc' && couponsSortField == 'mfg_name'"></i-bs>
            </div>
            <div class="col-2 title text-muted cursor-pointer" (click)="changeCouponsSorting('clips_count')">
              Clips
              <i-bs class="text-secondary" name="sortUpAlt" *ngIf="coupons.length != 0 && couponsSortType == 'asc' && couponsSortField == 'clips_count'"></i-bs>
              <i-bs class="text-secondary" name="sortDown" *ngIf="coupons.length != 0 && couponsSortType == 'desc' && couponsSortField == 'clips_count'"></i-bs>
            </div>
            <div class="col-2 title text-muted cursor-pointer" (click)="changeCouponsSorting('redeems_count')">
              Redeems
              <i-bs class="text-secondary" name="sortUpAlt" *ngIf="coupons.length != 0 && couponsSortType == 'asc' && couponsSortField == 'redeems_count'"></i-bs>
              <i-bs class="text-secondary" name="sortDown" *ngIf="coupons.length != 0 && couponsSortType == 'desc' && couponsSortField == 'redeems_count'"></i-bs>
            </div>
            <div class="col-2 title text-muted cursor-pointer" (click)="changeCouponsSorting('coupon_amount')">
              Value
              <i-bs class="text-secondary" name="sortUpAlt" *ngIf="coupons.length != 0 && couponsSortType == 'asc' && couponsSortField == 'coupon_amount'"></i-bs>
              <i-bs class="text-secondary" name="sortDown" *ngIf="coupons.length != 0 && couponsSortType == 'desc' && couponsSortField == 'coupon_amount'"></i-bs>
            </div>
          </div>

          <!-- Loader & Empty message -->
          <div class="row mt-4 mb-4">
            <div class="col-12 text-center">
              <div class="spinner-border text-info mt-4 mb-4" role="status" *ngIf="couponsLoading === true"></div>

              <div class="mt-4 pt-4" *ngIf="couponsLoading === false && coupons.length == 0">
                <i-bs class="text-black-50 mt-4 pt-4" name="creditCard" width="30" height="30"></i-bs>
                <div class="col-12 text-center text-black-50 mb-4 pb-4">Data not found</div>
              </div>
            </div>
          </div>

          <!-- Coupons -->
          <div class="row coupons-row border-bottom border-light m-1" *ngFor="let coupon of coupons | paginate: { itemsPerPage: couponsPageSize, currentPage: couponsPage, totalItems: couponsCount }; let i = index;">
            <div class="col-3 value text-muted cursor-pointer" (click)="showCouponPreviewModal(coupon, coupon_preview_modal)">
              {{ coupon.coupon_title }}
            </div>
            <div class="col-3 value text-muted">
              {{ coupon.mfg_name }}
            </div>
            <div class="col-2 value text-muted">
              {{ coupon.clips_count | number }}
            </div>
            <div class="col-2 value text-muted">
              {{ coupon.redeems_count | number }}
            </div>
            <div class="col-2 value text-muted">
              {{ coupon.coupon_amount | currency }}
            </div>
          </div>

          <!-- Pagination -->
          <div class="row pagination-row m-1">
            <div class="col-12">
              <pagination-controls class="label float-end mt-1" maxSize="4" autoHide="true" previousLabel=""
                nextLabel="" (pageChange)="onCouponsPageChange($event)" *ngIf="couponsCount > 0"></pagination-controls>
            </div>
          </div>

        </div>

        <!-- Payment details by date -->
        <div class="col-3 bg-white border-start border-3 border-light">

          <!-- Title -->
          <span class="text-muted fw-bold mt-2">Payments by Date</span>

          <!-- Header -->
          <div class="row coupons-header-row border-bottom m-1">
            <div class="col-6 title text-muted">Date</div>
            <div class="col-6 title text-muted">Payment</div>
          </div>

          <!-- Loader & Empty message -->
          <div class="row mt-4 mb-4">
            <div class="col-12 text-center">
              <div class="spinner-border text-info mt-4 mb-4" role="status" *ngIf="paymentsFilterLoading === true"></div>

              <div class="mt-4 pt-4" *ngIf="paymentsFilterLoading === false && paymentsFilter?.data.length == 0">
                <i-bs class="text-black-50 mt-4 pt-4" name="creditCard" width="30" height="30"></i-bs>
                <div class="col-12 text-center text-black-50 mb-4 pb-4">Data not found</div>
              </div>
            </div>
          </div>

          <!-- Data -->
          <div class="row coupons-row border-bottom border-light m-1" *ngFor="let item of paymentsFilter?.data">
            <div class="col-6 value text-muted">
              {{ item.date | date}}
            </div>
            <div class="col-6 value text-muted">
              {{ item.amount | currency }}
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>

</div>


<!-- Coupon Preview Modal -->
<ng-template #coupon_preview_modal>
  <div class="modal-header">
    <h6 class="modal-title text-muted float-start">{{ couponPreviewData.coupon_title }}</h6>

    <i-bs class="text-muted cursor-pointer float-end" name="xCircle" title="Close" (click)="hideCouponPreviewModal()"></i-bs>
  </div>

  <div class="modal-body">
    <app-preview-coupon module="CPG" page="regional-coupon-payments" [couponPreviewData]="couponPreviewData"></app-preview-coupon>
  </div>
</ng-template>
